/* BASIIC theme — facets.js : filter + sort via Section Rendering API */
(function () {
  'use strict';
  class FacetsForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.sectionId = this.dataset.section;
      if (!this.form) return;
      this.controller = null;
      this.onInput = window.basiic.debounce((e) => { if (e.target.type === 'number' || e.target.type === 'text') return; this.submit(); }, 200);
      this.onChange = (e) => { if (e.target.type === 'number') this.submit(); };
      this.onSubmit = (e) => { e.preventDefault(); this.submit(); };
      this.onDocClick = (e) => {
        const link = e.target.closest('[data-facet-remove]');
        if (!link) return;
        e.preventDefault();
        this.render(new URL(link.href, window.location.origin).search.replace('?', ''));
      };
      this.onPopState = () => this.render(window.location.search.replace('?', ''), false);
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('popstate', this.onPopState);
    }
    disconnectedCallback() {
      if (this.form) { this.form.removeEventListener('input', this.onInput); this.form.removeEventListener('change', this.onChange); this.form.removeEventListener('submit', this.onSubmit); }
      document.removeEventListener('click', this.onDocClick);
      window.removeEventListener('popstate', this.onPopState);
      if (this.controller) this.controller.abort();
    }
    submit() {
      const params = new URLSearchParams(new FormData(this.form));
      Array.from(params.keys()).forEach((k) => { if (params.get(k) === '') params.delete(k); });
      this.render(params.toString());
    }
    syncControls(doc) {
      // Mirror checked/value/disabled state from the freshly rendered form so removal links and popstate stay in sync.
      const freshForm = doc.querySelector(`facets-form[data-section="${this.sectionId}"] form`);
      if (!freshForm) return;
      this.form.querySelectorAll('input, select').forEach((cur) => {
        let fresh = null;
        if (cur.type === 'checkbox' || cur.type === 'radio') fresh = freshForm.querySelector(`[name="${CSS.escape(cur.name)}"][value="${CSS.escape(cur.value)}"]`);
        else fresh = freshForm.querySelector(`[name="${CSS.escape(cur.name)}"]`);
        if (!fresh) return;
        if (cur.type === 'checkbox' || cur.type === 'radio') { cur.checked = fresh.checked; cur.disabled = fresh.disabled; const opt = cur.closest('.facet__option'); opt && opt.classList.toggle('is-disabled', fresh.disabled); }
        else cur.value = fresh.value;
        const c = cur.closest('[data-facet-option-id]'); const fc = fresh.closest('[data-facet-option-id]');
        if (c && fc) { const a = c.querySelector('[data-facet-count]'); const b = fc.querySelector('[data-facet-count]'); if (a && b) a.textContent = b.textContent; }
      });
      this.form.querySelectorAll('details.facet > summary').forEach((sum, i) => { const f = freshForm.querySelectorAll('details.facet > summary')[i]; if (f) sum.textContent = f.textContent; });
    }
    async render(search, push = true) {
      const grid = document.getElementById(`ProductGridContainer-${this.sectionId}`);
      if (this.controller) this.controller.abort();
      const controller = new AbortController(); this.controller = controller;
      grid && grid.classList.add('is-loading');
      const url = `${window.location.pathname}?section_id=${this.sectionId}${search ? '&' + search : ''}`;
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error('Filter request failed (' + res.status + ')');
        const html = await res.text();
        if (controller !== this.controller) return; // stale response
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshGrid = doc.getElementById(`ProductGridContainer-${this.sectionId}`);
        if (freshGrid && grid) grid.innerHTML = freshGrid.innerHTML;
        const freshCount = doc.querySelector('[data-results-count]'); const count = document.querySelector('[data-results-count]');
        if (freshCount && count) count.textContent = freshCount.textContent;
        const freshActive = doc.getElementById(`ActiveFacets-${this.sectionId}`); const active = document.getElementById(`ActiveFacets-${this.sectionId}`);
        if (freshActive && active) active.innerHTML = freshActive.innerHTML;
        this.syncControls(doc);
        if (push) window.history.pushState({}, '', `${window.location.pathname}${search ? '?' + search : ''}`);
      } catch (err) {
        if (err.name === 'AbortError') return;
        if (grid) {
          const msg = document.createElement('div');
          msg.className = 'form-message form-message--error'; msg.setAttribute('role', 'alert');
          msg.textContent = 'We could not update the results. Please try again.';
          grid.prepend(msg);
        }
      } finally {
        if (controller === this.controller) { grid && grid.classList.remove('is-loading'); this.controller = null; }
      }
    }
  }
  if (!customElements.get('facets-form')) customElements.define('facets-form', FacetsForm);
})();
